import { graphqlClient } from '@/graphql/graphql-client';
import {
  INSERT_ORG_CONTRACT_SIGNATURE_LOG_MUTATION,
  UPDATE_ORG_CONTRACT_SIGNATURE_LOG_MUTATION,
} from '@/graphql/mutations';
import type {
  OrgContractSignatureLogInsertInput,
  OrgContractSignatureLogUpdateInput,
  MutateOrgContractSignatureLogResponse,
} from '../types/signature-log.types';

export interface InsertOrgContractSignatureLogResponse {
  insertOrgContractSignatureLog: MutateOrgContractSignatureLogResponse & { itemId: string };
}

export interface UpdateOrgContractSignatureLogResponse {
  updateOrgContractSignatureLog: MutateOrgContractSignatureLogResponse;
}

export const createContractSignatureLog = async (
  input: OrgContractSignatureLogInsertInput
): Promise<InsertOrgContractSignatureLogResponse> => {
  const response = await graphqlClient.request(INSERT_ORG_CONTRACT_SIGNATURE_LOG_MUTATION, input);

  const result = response.insertOrgContractSignatureLog;
  if (!result?.itemId) {
    throw new Error('No itemId returned from insert');
  }
  return { insertOrgContractSignatureLog: { ...result, itemId: result.itemId } };
};

export const updateContractSignatureLog = async (
  itemId: string,
  input: OrgContractSignatureLogUpdateInput
): Promise<UpdateOrgContractSignatureLogResponse> => {
  const response = await graphqlClient.request(UPDATE_ORG_CONTRACT_SIGNATURE_LOG_MUTATION, {
    ItemId: itemId,
    ...input,
  });

  const result = response.updateOrgContractSignatureLog;
  if (!result) {
    throw new Error('No result returned from update');
  }

  return { updateOrgContractSignatureLog: result };
};
